import { Message } from 'element-ui';

export function toastSuccess(msg){
    toast(msg,'success')
}
export function toastError(msg){
    toast(msg,'error')
}
export function toastWarning(msg){
    toast(msg,'warning')
}
export function toast(msg,type){
    Message(
        {
            message: msg,
            type: type
        }
    )
}


// WEBPACK FOOTER //
// ./src/components/common/toast.js